const SimulationPricingsDailyBenefitExtraForm = () => {
  return null;
};

export default SimulationPricingsDailyBenefitExtraForm;
